export default class formConfig {
  // 区管单位
  static configList() {
    return [
      {
        title: "项目基本信息",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "项目名称：",
            value: "prjName",
            type: "input",
            width: "100%",
            disabled: true,
          },
          {
            label: "招标编号：",
            type: "input",
            value: "tenderReference",
            disabled: true,
          },
          {
            label: "标段号：",
            type: "input",
            value: "section",
            disabled: true,
          },
          {
            label: "招标类别：",
            type: "input",
            value: "tenderClassNumName",
            disabled: true,
          },
          {
            label: "招标内容：",
            type: "input",
            value: "tenderContent",
            disabled: true,
          },
          {
            label: "招标方式：",
            type: "input",
            value: "tenderTypeNumName",
            disabled: true,
          },
          {
            label: "招标监管部门：",
            type: "input",
            value: "regulatorsName",
            disabled: true,
          },
          {
            label: "变更前项目负责人（总监）：",
            type: "input",
            value: "personName",
            disabled: true,
          },
          {
            label: "身份证号：",
            type: "input",
            value: "idCard",
            disabled: true,
          },
        ]
      },
      {
        title: "项目负责人要求",
        name: "2",
        icon: "",
        formConfigList: [
          {
            type: "slot",
            class: "formList",
            slotName: "managerList"
          }
        ]
      },
      {
        title: "联合投标单位信息",
        name: "3",
        icon: "",
        formConfigList: [
          {
            type: "slot",
            class: "formList",
            slotName: "unionList"
          }
        ]
      },
      {
        title: "项目负责人/总监变更申请",
        name: "4",
        icon: "",
        formConfigList: [
          {
            label: "投标项目负责人/总监：",
            value: "basicinfoChangeName",
            type: "input",
            disabled: true
          },
          {
            label: "证件类型：",
            value: "idCardTypeName",
            type: "input",
            disabled: true
          },
          {
            label: "证件号码：",
            value: "chageIdCard",
            type: "input",
            disabled: true
          },
        ]
      },
      {
        title: "项目负责人/总监变更申请扫描件",
        name: "5",
        icon: "",
        formConfigList: [
          {
            label: "变更申请扫描件：",
            type: "slot",
            slotName: "uploadFile",
            width: "100%",
          },
        ]
      },
      {
        title: "状态",
        name: "6",
        icon: "",
        formConfigList: [
          {
            label: "状态：",
            type: "input",
            value: "stateName",
            disabled: true,
          },
          {
            label: "历史审核记录：",
            type: "slot",
            class: "list",
            slotName: "auditBtn",
          },
        ]
      },
    ];
  }
}
